import { Table, TableContainer, type TableContainerProps } from '@shared/components';

import { QBankStructureTableBody } from '../../containers';
import { QBankStructureTableHeader } from '../qbank-structure-table-header';

import { type QBankStructureSettingSectionTableData } from './type';

interface QBankStructureTableProps extends TableContainerProps {
  data: QBankStructureSettingSectionTableData[];
  handleDeleteMenu: (id: string) => void;
}

export default function QBankStructureTable(props: Readonly<QBankStructureTableProps>) {
  const { data, handleDeleteMenu, ...restProps } = props;

  if (data.length === 0) {
    //TODO: Add empty state of subject here
    return null;
  }

  return (
    <TableContainer
      {...restProps}
      sx={{
        borderRadius: (theme) => theme.shape.rounded(2),
        overflow: 'hidden',
        border: '1px solid',
        borderColor: (theme) => theme.palette.grey[300],
        ...restProps.sx,
      }}
    >
      <Table
        stickyHeader
        size='small'
        sx={{
          border: 'none',
          borderCollapse: 'initial',
          mb: '-1px',
        }}
      >
        <QBankStructureTableHeader />
        <QBankStructureTableBody rows={data} handleDeleteMenu={handleDeleteMenu} />
      </Table>
    </TableContainer>
  );
}
